import type { TFunction } from 'i18next';

import { uniqueOptions, type FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import type { ExchangeRate } from '@nucleus-commerce/api-client/platform';

/**
 * Filters of the exchange rates table; `t` is the `exchangeRates` namespace. Options come from
 * the loaded rates, since base currencies and sources are whatever has been recorded.
 */
export function exchangeRateFilters(
  t: TFunction,
  rates: readonly ExchangeRate[],
): Array<FilterDef<ExchangeRate>> {
  return [
    {
      key: 'baseCurrency',
      label: t('fields.baseCurrency'),
      type: 'enum',
      pinned: true,
      aliases: ['base'],
      options: uniqueOptions(rates, (rate) => rate.baseCurrency),
      getValue: (rate) => rate.baseCurrency,
    },
    {
      key: 'source',
      label: t('columns.source'),
      type: 'enum',
      pinned: true,
      options: uniqueOptions(
        rates,
        (rate) => rate.source,
        (source) => (source === 'manual' ? t('source.manual') : t('source.other', { source })),
      ),
    },
  ];
}
